<svg style="display: block" [ngStyle]="getStyles()" [attr.viewBox]="viewBox" [attr.width]="width" [attr.height]="height">
  <use [attr.xlink:href]="svgPath()"></use>
</svg>
